import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';

@Component({
    selector: 'wci-mid-page-cta',
    imports: [ButtonComponent],
    templateUrl: './mid-page-cta.component.html',
    styles: ``,
})
export class MidPageCtaComponent {}
